import { useEffect, useRef } from 'react'

const useEffectAfterFirstRender = (
  effect: () => void,
  deps: React.DependencyList
) => {
  const hasMounted = useRef(false)

  useEffect(() => {
    if (hasMounted.current) {
      effect()
    } else {
      hasMounted.current = true
    }
  }, deps)
}

export default useEffectAfterFirstRender
